MS = window.MS || {};

(function ($) {
  var $window = $(window);
  var $document = $(document);
  var $html = $('html');
  var $body = $('body');

  var IS_PLAYING = 'is-playing';
  var IS_PLAYED = 'is-played';
  var IS_REPLAY = 'is-replay';
  var IS_ACTIVE = 'is-active';
  var IS_VISIBLE = 'is-visible';
  var IS_ANIMATE = 'is-animate';
  var IS_STARTED = 'is-started';

  function isMobile() {
    return ('ontouchstart' in document.documentElement);
  }

  MS.tableandsalt_hero = {
    cookieName: 'tas_cookie',
    init: function () {
      this.$body = $('body');
      this.$element = $('.js-ts-hero');
      this.$nextElement = this.$element.next();
      this.$videoElement = this.$element.find('.js-ts-video')
      this.$videoPlayer = this.$videoElement.find('.js-ts-video-player');
      this.$video = this.$videoElement.find('video');
      this.$videoBtn = this.$element.find('.ms-ts-hero__video__btn');
      this.$modules = this.$element.find('.js-ts-module');
      this.$inPageNav = this.$element.find('.js-ts-in-page-nav');
      this.$buttons = this.$inPageNav.find('a');
      this.$scrollAccordance = this.$element.find('.js-ts-scroll-accordance');
      this.$shareToggle = this.$element.find('.ms-ts-hero__share__toggle');
      this.$shareSocial = this.$element.find('.ms-ts-hero__share__social');

      this.Player = {};
      this.isPlaying = false;
      this.indexModule = 0;
      this.activeClass = '';
      this.modulesLength = this.$modules.length - 1;

      this.PLAYER_VARS = {
        autoplay: 1,
        autohide: 1,
        modestbranding: 1,
        rel: 0,
        showinfo: 0,
        controls: 0,
        loop: 0,
        disablekb: 1,
        enablejsapi: 1,
        iv_load_policy: 3,
        playsinline: 1,
        ecver: 2
      };

      if (isMobile()) {
        this.$videoElement.addClass(IS_PLAYED);
      }

      // Video is already played by the user. Disable autoplay and update the CTA text
      if( this.cookieExist() ) {
        this.$videoElement.addClass(IS_PLAYED);
        this.$videoElement.addClass(IS_REPLAY);
      }

      // Run each callback when YT Player API is ready
      if (typeof (YT) === 'undefined' || typeof (YT.Player) === 'undefined') {
        var that = MS.tableandsalt_hero;

        window.onYouTubePlayerAPIReady = function () {
          that.createPlayer();
        }
      } else {
        this.createPlayer();
      }

      // Initialize ScrollMagic and TimelineMax
      if (this.$modules.length > 1) {
        this.ScrollMagicController = new ScrollMagic.Controller({ paused: true });
        this.TimelineMax = new TimelineMax();
        this.scrollInteractions();
        this.handleInPageNav();
      }

      this.handleShare();
    },
    bindUIEvents: function () {
      var that = MS.tableandsalt_hero;

      // play the video on click
      that.$videoBtn.on('click', function () {
        that.handleTogglePlay();
      });
    },
    createPlayer: function () {
      var that = MS.tableandsalt_hero;

      that.Player = new YT.Player(that.$videoPlayer[0].id, {
        playerVars: that.PLAYER_VARS,
        videoId: that.$videoPlayer.data('video-id'),
        events: {
          onReady: that.handlePlayerOnReady.bind(this),
          onStateChange: that.handlePlayerStateChange.bind(this)
        }
      });
    },
    scrollInteractions: function () {
      var that = MS.tableandsalt_hero;
      var duration = (that.$modules.length * 500) + '%';
      var $imageSalt = $(that.$element).find('.ms-ts-hero__tip__salt')[0];

      that.$modules.each(function (index, module) {
        if (index === 0) {
          // Hero Video Module
          that.TimelineMax
            .fromTo(module, 1, {y: '0%'}, {
              y: '-100%',
              onStart: function () {
                if (!that.$element.hasClass(IS_STARTED)) {
                  that.$element.addClass(IS_STARTED);
                }

                that.handleInPageNav.bind(this, index, 'forward');
              },
              onReverseComplete: function () {
                var visible = !that.$videoElement.hasClass(IS_PLAYING);
                that.handleInPageNav(1, 'reverse');
                that.handleControlsVisiblity(visible);

                setTimeout(function () {
                  that.$scrollAccordance.addClass(IS_ANIMATE);
                }, 200);
              },
              ease: Linear.easeIn
            }, 'first1');
        } else if (index >= 1) {
          // Tips Module
          var $tips = $(module).find('.js-ts-tip-section');
          var $image = $($tips[1]).find('.ms-ts-hero__tip__section__image')[0];
          var $block = $($tips[1]).find('.ms-ts-hero__tip__section__block')[0];
          var $hidden = $($tips[1]).find('.ms-ts-hero__tip__section__hidden')[0];
          var $hidden1 = $($tips[1]).find('.ms-ts-hero__tip__section__hidden')[1];
          var $photo = $($tips[3]).find('.ms-ts-hero__tip__section__photo')[0];
          var $details = $($tips[3]).find('.ms-ts-hero__tip__section__details')[0];
          var $helper = $($tips[3]).find('.ms-ts-hero__tip__section__helper')[0];
          var $helper1 = $($tips[3]).find('.ms-ts-hero__tip__section__helper')[1];

          if (index === 1) {
            // initial animation
            that.TimelineMax
              .fromTo(module, 1, {y: '100%'}, {
                y: '0%',
                onStart: that.handleOnStartEvent.bind(this, index),
                onComplete: that.handleOnCompleteEvent.bind(this, index, 'forward', $tips[2]),
                onReverseComplete: that.handleOnReverseComplete.bind(this, index, 'reverse', $tips[2]),
                ease: Linear.easeIn
              }, 'first' + index)
              .fromTo($imageSalt, 0.3, {y: '-100%', x: '-100px'}, {y: '0%', x: '0%', ease: Linear.easeOut}, 'first' + index + '+=0.7')
              .fromTo($image, 1.2, { y: '100%' }, { y: '0%', ease: Linear.easeIn }, 'first' + index + '-=0.1');
          } else {
            var $prevTips = $(that.$modules[index - 1]).find('.js-ts-tip-section');

            that.TimelineMax
              .to($($prevTips[3]).find('.ms-ts-hero__tip__section__photo')[0], 1, {x: '-200%', ease: Linear.easeIn}, 'first' + index)
              .to($($prevTips[3]).find('.ms-ts-hero__tip__section__details')[0], 1, {x: '100%', ease: Linear.easeIn}, 'first' + index)
              .fromTo(module, 1, {y: '100%'}, {
                y: '0%',
                onStart: that.handleOnStartEvent.bind(this, index),
                onComplete: that.handleOnCompleteEvent.bind(this, index, 'forward', $tips[2]),
                onReverseComplete: that.handleOnReverseComplete.bind(this, index, 'reverse', $tips[2]),
                ease: Linear.easeIn
              }, 'first' + index)
              .fromTo($tips[1], 1, { y: '-200%' }, {
                y: '0%',
                onStart: that.handleInPageNavColor.bind(this, index, true),
                onComplete: that.handleInPageNavColor.bind(this, index, false),
                onReverseComplete: that.handleInPageNavColor.bind(this, index, true),
                ease: Linear.easeIn
              }, 'first' + index)
              .fromTo($imageSalt, 0.3, {y: '-100%', x: '-100px'}, { y: '0%', x: '0%', ease: Linear.easeOut }, 'first' + index + '+=1')
              .fromTo($image, 1, {y: '200%'}, {y: '0%', ease: Linear.easeIn}, 'first' + index + '+=0.4')
          }

          // animate second section
          that.TimelineMax
            .fromTo($tips[0], 1, { y: '0%', opacity: 1 }, { y: '-100%', opacity: 0, ease: Linear.easeOut }, 'second' + index)
            .to($imageSalt, 0.2, { opacity: '0'}, 'second' + index)
            .fromTo($tips[2], 1, { y: '100%' }, { y: '0%', ease: Linear.easeIn }, 'second' + index)

            // animate third section
            .to($image, 1, { y: '-100%', ease: Linear.easeOut }, 'third' + index + '+=2')
            .fromTo($hidden, 1, { opacity: 1 }, {
              opacity: 0,
              onComplete: function () {
                $($block).addClass(IS_VISIBLE);
              }
            }, 'third' + index + '+=1.6')
            .to($hidden1, 1, {
              onReverseComplete: function () {
                $($block).removeClass(IS_VISIBLE);
              }
            }, 'third' + index + '+=2.6')
            .to($imageSalt, 0, { y: '-100%', x: '-100px', opacity: 1 }, 'third' + index )

            // fourth
            .fromTo($tips[1], 1, { y: '0%' }, {
              y: '-100%',
              onStart: that.handleInPageNavColor.bind(this, index, true),
              onReverseComplete: that.handleInPageNavColor.bind(this, index, false),
              ease: Linear.easeOut
            }, 'fourth' + index + '+=0.1')

            // animate fifth section
            .to($tips[2], 1, { y: '-100%', ease: Linear.easeOut }, 'fifth' + index)

            // animate sixth section
            .fromTo($helper, 1, { opacity: 1 }, {
              opacity: 0,
              onStart: function () {
                $($details).addClass(IS_VISIBLE);
              }
            }, 'sixth' + index + '-=0.2')
            .to($hidden1, 1, {
              onReverseComplete: function () {
                $($details).removeClass(IS_VISIBLE);
              }
            }, 'sixth' + index + '-=0.3')
            .fromTo($photo, 1, { x: '-200%' }, { x: '0%', ease: Linear.easeIn }, 'sixth' + index + '-=1')
        }
      });

      that.ScrollMagicScene = new ScrollMagic.Scene({
        triggerElement: '.js-ts-hero',
        triggerHook: 'onLeave',
        duration: duration,
        loglevel: 1
      })
      .setPin('.js-ts-hero')
      .setTween(that.TimelineMax)
      .addTo(that.ScrollMagicController);

      that.ScrollMagicScene.on('enter', function (e) {
        if (e.scrollDirection === 'REVERSE') {
          that.handleEndOfSlide(99);
        }
      });

      that.ScrollMagicScene.on('leave', function (e) {
        if (e.scrollDirection === 'FORWARD') {
          that.handleEndOfSlide(that.modulesLength);
        }
      });

      // change the behavior of controller to animate scroll instead of jump
      that.ScrollMagicController.scrollTo(function (newPos, duration) {
        TweenMax.to(window, duration, { scrollTo: { y: newPos, autoKill: true }});
      });

      that.handleTipModuleUIEvents();
    },
    handlePlayEvent: function (state) {
      var that = MS.tableandsalt_hero;

      if (state === YT.PlayerState.PLAYING) {
        that.isPlaying = true;
        that.$videoElement.addClass(IS_PLAYING);
        that.$body.addClass(IS_PLAYING);
        that.$videoElement.removeClass(IS_REPLAY);

        // Video is played and the cookie not found. Set the cookie.
        if (!this.cookieExist()) {
          this.setCookie();
        }

        // hide slide controls when playing
        that.handleControlsVisiblity(false);
      } else if (state === YT.PlayerState.ENDED) {
        that.isPlaying = false;
        that.$videoElement.removeClass(IS_PLAYING, IS_PLAYED);
        that.$body.removeClass(IS_PLAYING);
        that.$videoElement.addClass(IS_REPLAY);

        // show slide controls when video has ended
        that.handleControlsVisiblity(true);

        // slide down to the first tip module
        if (that.ScrollMagicController.scrollPos() < window.innerHeight) {
          that.tweenTo(1, 1.5);
        }
      }
    },
    handleTogglePlay: function () {
      var that = MS.tableandsalt_hero;

      if (!that.isPlaying) {
        that.Player.playVideo();
      }
    },
    handlePlayerOnReady: function (e) {
      var that = MS.tableandsalt_hero;
      e.target.mute();
      that.bindUIEvents();

      if (that.$videoElement.hasClass(IS_PLAYED)) {
        that.Player.stopVideo();
        that.handleInPageNav(0, 'forward');
        that.handleControlsVisiblity(true);
        this.$scrollAccordance.addClass(IS_ANIMATE);
      }
    },
    handlePlayerStateChange: function (e) {
      var that = MS.tableandsalt_hero;
      that.handlePlayEvent(e.data);
    },
    handleChangeColor: function (id) {
      var that = MS.tableandsalt_hero;
      var $currentModule = $(that.$modules[id]);
      var color = $($currentModule).data('color');

      // Change color of scroll accordance
      that.$scrollAccordance
        .removeClass(that.activeClass)
        .addClass(color);

      that.indexModule = id;
      that.activeClass = color;
    },
    handleInPageNavColor: function (id, change) {
      var that = MS.tableandsalt_hero;
      var $currentModule = $(that.$modules[id]);
      var color = $($currentModule).data('color');

      // Change color of in-page nav's active bullet
      if (change) {
        if (color === 'yellow') {
          that.$inPageNav.addClass(color);
        }
      } else {
        that.$inPageNav.removeClass('yellow');
      }
    },
    handleInPageNav: function (id, direction) {
      var that = MS.tableandsalt_hero;
      var index = (index === 'undefined') ? 0 : id;
      var is_forward = (direction === 'forward');

      that.$buttons.each(function(index, button) {
        $(button).removeClass(IS_ACTIVE);
      });

      $(that.$buttons).eq(is_forward ? index : index - 1).addClass(IS_ACTIVE);
    },
    nextSlide: function (labelName) {
      var that = MS.tableandsalt_hero;
      var labelTime = that.TimelineMax.getLabelTime(labelName);
      var scrollDuration = that.ScrollMagicScene.duration();
      var duration = that.TimelineMax.duration();
      var scrollPosition = ((((labelTime + 0.001) / duration) * 100) / 100) * scrollDuration;

      that.ScrollMagicController.scrollTo(Math.round(scrollPosition), 1);
    },
    tweenTo: function (index, speed) {
      var that = MS.tableandsalt_hero;
      var labelName = index > 1 ? 'first' + index : index === 1 ? 'second1' : 'first1';
      var labelTime = that.TimelineMax.getLabelTime(labelName);
      var time = index > 1 ? labelTime + 1.401 : index === 1 ? labelTime : 0;
      var scrollDuration = that.ScrollMagicScene.duration();
      var duration = that.TimelineMax.duration();
      var scrollPosition = (((time / duration) * 100) / 100) * scrollDuration;

      that.ScrollMagicController.scrollTo(Math.round(scrollPosition), speed || 0);
    },
    handleTipModuleUIEvents: function () {
      var that = MS.tableandsalt_hero;

      that.$buttons.each(function (index, button) {
        // In page nav buttons click event
        $(button).on('click', function (e) {
          that.tweenTo(index);
          e.preventDefault();
        });
      });

      // Scroll Accordance click event
      that.$scrollAccordance.on('click', function () {
        var nextLabel = that.TimelineMax.getLabelAfter();

        if (nextLabel !== null) {
          var str = nextLabel.indexOf('first') !== -1 ? nextLabel.replace(/first/g, 'second') : nextLabel;
          that.nextSlide(str);
        } else {
          var scrollY = (window.scrollY || window.pageYOffset);
          var bounding = that.$nextElement[0].getBoundingClientRect();
          that.ScrollMagicController.scrollTo(scrollY + bounding.top, 1);
        }
      });
    },
    handleEndOfSlide: function (id) {
      var that = MS.tableandsalt_hero;
      that.handleScrollAccordance(that.modulesLength !== id);
      that.$scrollAccordance.removeClass(IS_ANIMATE);
    },
    handleOnCompleteEvent: function (id, direction, element) {
      var that = MS.tableandsalt_hero;
      that.handleInPageNav(id, direction, element);
      that.handleControlsVisiblity(true);
      that.$scrollAccordance.removeClass(IS_ANIMATE);

      setTimeout(function () {
        that.$scrollAccordance.addClass(IS_ANIMATE);
      }, 200);
    },
    handleOnReverseComplete: function (id, direction, element) {
      var that = MS.tableandsalt_hero;
      var newId = id - 1;

      that.handleInPageNav(id, direction, element);
      that.handleChangeColor(newId);
      that.handleInPageNavColor(newId, true);
      that.handleControlsVisiblity(newId !== 0);
      that.$scrollAccordance.removeClass(IS_ANIMATE);

      setTimeout(function () {
        that.$scrollAccordance.addClass(IS_ANIMATE);
      }, 200);
    },
    handleOnStartEvent: function (id) {
      var that = MS.tableandsalt_hero;

      if (!that.$inPageNav) {
        return;
      }

      that.handleChangeColor(id);
    },
    handleControlsVisiblity: function (show) {
      var that = MS.tableandsalt_hero;

      that.handleScrollAccordance(show);

      if (!show) {
        that.$inPageNav.removeClass(IS_VISIBLE);
        that.$shareToggle.parent().removeClass(IS_VISIBLE);
      } else {
        that.$inPageNav.addClass(IS_VISIBLE);
        that.$shareToggle.parent().addClass(IS_VISIBLE);
      }
    },
    handleScrollAccordance: function (show) {
      var that = MS.tableandsalt_hero;

      if (!show) {
        that.$scrollAccordance.removeClass(IS_VISIBLE);
      } else {
        that.$scrollAccordance.addClass(IS_VISIBLE);
      }
    },
    handleShare: function () {
      this.$shareToggle.on('click', function (e) {
        e.preventDefault();
        var isOpen = $(this).hasClass(IS_VISIBLE);
        $(this).toggleClass(IS_VISIBLE, !isOpen);
      });

      this.$shareSocial.on('click', function (e) {
        e.preventDefault();
        var ms_popup;
        var ms_href = $(this).attr('href');
        var ms_dt = $(this).attr('data-track');

        ms_popup = ($(this).hasClass('pn')) ? window.open(ms_href, 'Share', 'height=600,width=800') : window.open(ms_href, 'Share', 'height=325,width=600');

        if (window.focus) {
          ms_popup.focus();
        }
      });
    },
    cookieExist: function () {
      var that = MS.tableandsalt_hero;
      var dc = document.cookie;
      var prefix = that.cookieName + "=";
      var begin = dc.indexOf("; " + prefix);
      var theCookie = null;

      // Check if `tas_cookie` cookie exist
      if (begin == -1) {
        begin = dc.indexOf(prefix);
        if (begin != 0) {
          return false;
        }
      } else {
        begin += 2;
        var end = document.cookie.indexOf(";", begin);
        if (end == -1) {
          end = dc.length;
        }
      }

      // because unescape has been deprecated, replaced with decodeURI
      // return unescape(dc.substring(begin + prefix.length, end));
      theCookie = decodeURI(dc.substring(begin + prefix.length, end));

      if (theCookie === null) {
        return false;
      } else {
        return true;
      }
    },
    setCookie: function () {
      var date = new Date();
      date.setTime(date.getTime() + (365 * 24 * 60 * 60 * 1000));
      expires = "; expires=" + date.toUTCString();
      document.cookie = this.cookieName + "=true" + expires + "; path=/";
    }
  };
})(jQuery);
